import { z } from 'zod';
export const COLOR_SCHEMA = z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/)
    .nullable()
    .optional();
//# sourceMappingURL=color.js.map